// 初期表示
export const PAGE_INIT = "corp/overseas/disclosure/PAGE_INIT";
// ページ遷移
export const PAGE_CHANGE = "corp/overseas/disclosure/PAGE_CHANGE";
